import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import { FilteredProject, Tag } from '../../types/common';
import CardTag from '../tag/Tag';

type ProjectCardType = {
  project: FilteredProject;
  tags: Tag[];
};

const ProjectCard = ({ project, tags }: ProjectCardType) => {
  const projectTags = tags.filter((tag) => project.tags.includes(tag.tag));
  const projectImage = project.img[0].path.childImageSharp.gatsbyImageData;
  return (
    <AnchorLink
      to={`/${project.slug}`}
      className="flex flex-col justify-between max-w-md rounded-lg overflow-hidden shadow-sm shadow-slate-800"
    >
      <GatsbyImage image={projectImage} alt={project.slug} />
      <div className="px-2 py-4">
        <div className="font-bold text-xl mb-2">{project.title}</div>
        <p className="text-accentGray max-w-sm text-md text-justify text-ellipsis  overflow-hidden">
          {project.description}
        </p>
      </div>
      <div className="flex gap-3 flex-wrap justify-start items-center m-4">
        {projectTags.map((tag) => (
          <div key={tag.id} className="flex justify-center items-center">
            <CardTag tag={tag.tag} tagColor={tag.color} />
          </div>
        ))}
      </div>
    </AnchorLink>
  );
};

export default ProjectCard;
